import styled from 'styled-components'

const Fullscreen = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
`

export default Fullscreen
